import { STORAGE_KEY_CAS_NUMBER } from '@Containers/CasNumber/constants';
import { casNumberState } from '@Containers/CasNumber/selectors';
import AppStorage from '@Services/AppStorage';

export const getStateFromStorage = () =>
  AppStorage.instance.get(STORAGE_KEY_CAS_NUMBER);

export const saveStateToStorage = (state) =>
  AppStorage.instance.set(STORAGE_KEY_CAS_NUMBER, casNumberState(state));

export const removeStateFromStorage = () =>
  AppStorage.instance.remove(STORAGE_KEY_CAS_NUMBER);
